// Implements: F-UIX-008
/**
 * The four login messages the backend emits, copied byte for byte.
 *
 * Sources, read-only and never imported by anything that builds:
 *   backend/src/prototyper/identity/application/use_cases/log_in.py:99, :104, :107
 *   backend/src/prototyper/identity/application/attempt_buckets.py:64
 *
 * The second-factor branch of the login screen depends on these exact bytes
 * until `phase-3-mockups` publishes the `X-Second-Factor` header (design DD7),
 * and the comparison is EXACT equality on purpose: the handover writes the
 * refusal lowercased and unpunctuated, so a substring or case-insensitive
 * match would look correct while hiding the drift.
 *
 * They live in one module, imported both by the MSW handlers and by the login
 * hook, so the contract test compares production code against the contract
 * instead of comparing the contract with itself.
 */

/** `log_in.py:99` — wrong email or wrong password, and the field is not revealed. */
export const REFUSAL = "Las credenciales no son válidas.";

/** `log_in.py:104` — the account has a second factor and no code was sent. */
export const SECOND_FACTOR_REQUIRED = "Falta el código del segundo factor.";

/** `log_in.py:107` — a code was sent and it does not match. */
export const SECOND_FACTOR_INVALID = "El código del segundo factor no es válido.";

/** `attempt_buckets.py:64` — the attempt bucket is closed; this is a wait, not an error. */
export const TOO_MANY_ATTEMPTS = "Demasiados intentos fallidos. Vuelve a intentarlo en 30 segundos.";
